import BlobFilePreview from "@/components/BlobPreview";
import { appInboxAttachmentBlob } from "@/lib/api";

/**
 * The preview of an applications-inbox email attachment, shown by what the file is rather than what
 * the sender called it. The sender chooses both the name and the declared content type, so a
 * `statement.pdf` declared as `text/html` must never reach a frame; `BlobPreview` decides from the
 * blob's own type. Kept apart from the dialog so it carries no Radix component, which the pinned Jest
 * resolver cannot mount.
 *
 * `fetchBlob` is the inbox's own attachment reader; the department inboxes share this dialog and pass
 * theirs. It defaults to the applications inbox.
 *
 * @param {{messageId: string, att: {id: string, name?: string}, fetchBlob?: (messageId: string, attId: string, signal?: AbortSignal) => Promise<Blob>}} props
 */
export default function AttachmentPreview({ messageId, att, fetchBlob = appInboxAttachmentBlob }) {
  return (
    <BlobFilePreview
      loadKey={`${messageId}:${att.id}`}
      load={(signal) => fetchBlob(messageId, att.id, signal)}
      name={att.name || "file"}
      downloadName={(att.name || "file").split(" → ").pop()}
      frameClassName="w-full h-[72vh] border rounded bg-white"
      imageClassName="max-w-full max-h-[72vh] mx-auto object-contain"
      testIdPrefix="attachment-preview"
    />
  );
}
